import { Component, type ErrorInfo, type ReactNode } from 'react';

// Глобальный барьер: любой throw в render = fallback с Reload вместо белого экрана.
export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[crm] render error', error, info.componentStack); // no-console отключён для error-level в eslint-config
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 p-8 text-center">
          <h1 className="text-xl font-semibold">Что-то пошло не так</h1>
          <button type="button" onClick={() => window.location.reload()} className="rounded border px-4 py-2">
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
